import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Player, ControlBar, BigPlayButton } from 'video-react';
import stopMediaStream from 'stop-media-stream';

import styles from './style.css';
import UQButton from '../../../../uq-ui/components/button';
import Icon from '../../../../icons/Icon';
import UiIcon from "../../../../uq-ui/components/ui-icon";

import CanvasComponentsControlsBottom from '../../../../canvas/ui/components/controls-bottom';
import StickersComponentsTryAgainBtn from '../../components/try-again-btn';
import CanvasComponentsBarToggler from '../../../../canvas/ui/components/bar-toggler';
import { mediaVideoStateSelector } from '../../../store/media-video/selectors';
import { fallbackMediaStreamRecord, onVideoSelected, resetState, videoDone } from '../../../store/media-video/actions';
import { setGoAppModalVisibility } from '../../../../layout/store/actions';
import { checkStepValidation } from '../../../store/create-llama/actions';
import Div100vh from '../../../../uq-ui/components/div-100';
import { createLlamaIdSelector } from '../../../store/create-llama/selectors';
import goolgeAnalytics from '../../../../user/analytics/GoogleAnalytics';
import StickersComponentsRecordVideoBtn from '../../components/record-video-btn';

const cameraToggleImage = require('./icons/flip-icon.png');
const cameraToggleImage2x = require('./icons/flip-icon@2x.png');
const flashImage = require('./icons/flash-icon.png');
const flashImage2x = require('./icons/flash-icon@2x.png');

const MAX_DURATION_SEC = 60;

const supports = navigator.mediaDevices && navigator.mediaDevices.getSupportedConstraints() || {};
const supportsFacingMode = supports['facingMode'] === true;

class StickersScreensNewVideoRecord extends Component {

  videoContainerRef;
  videoRef;
  videoEl;
  mediaRecorder;
  stream;
  isFacingMode = supportsFacingMode;

  currentVideoTrack;
  isFlashlightEnabled = false;

  constructor(props) {
    super(props);
    this.state = {
      isCanvasBarShown: false,
      isMuted: true,
      isMediaSuccess: false,
      isRecording: false,
      hasFlashlight: false
    };
  }

  componentDidMount() {
    goolgeAnalytics.setCurrentScreen('web-new-video-record-stream');

    window.addEventListener('orientationchange', this.onOrientationChange);

    this.videoEl = document.createElement('video');
    const videoWidth = window.innerWidth;
    const videoHeight = window.innerHeight;
    this.videoEl.controls = false;
    this.videoEl.muted = true;
    this.videoEl.height = videoHeight;
    this.videoEl.width = videoWidth;
    this.requestUserMedia({ needRender: true });
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.onOrientationChange);
    if (this.stream) {
      const videoTrack = this.stream.getVideoTracks();
      const audioTrack = this.stream.getAudioTracks();
      if (videoTrack.length > 0) {
        this.stream.removeTrack(videoTrack[0]);
      }
      if (audioTrack.length > 0) {
        this.stream.removeTrack(audioTrack[0]);
      }
      stopMediaStream(this.stream);
      if (this.videoEl) {
        this.videoEl.pause();
        this.videoEl.srcObject = null;
      }
    }
  }

  onOrientationChange = () => {
    console.log('screen.orientation.angle', screen.orientation.angle);
  };

  toggleFacingMode = () => {
    if (this.stream) {
      stopMediaStream(this.stream);
      this.videoEl.pause();
      this.videoEl.srcObject = null;
      this.isFacingMode = !this.isFacingMode;

      this.requestUserMedia({ needRender: false });
    }
  };

  requestUserMedia = (options) => {
    (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia)({
      audio: true,
      video: {
        frameRate: 30,
        width: { min: 320, ideal: 480 },
        height: { min: 320, ideal: 480 },
        facingMode: this.isFacingMode ? 'user' : 'environment'
      }
    }, (stream) => this.runStream(stream, options), (error) => {
      this.onMediaError(error);
    });
  };

  runStream = (stream, { needRender }) => {
    this.stream = stream;
    const chunks = [];

    this.videoEl.srcObject = stream;
    if (needRender && this.videoContainerRef) {
      this.videoContainerRef.appendChild(this.videoEl);
    }
    this.videoEl.play()
      .catch((e) => {
        this.props.fallbackMediaStreamRecord();
      });
    this.mediaRecorder = new MediaRecorder(stream);
    this.mediaRecorder.onstop = (e) => {
      const blob = new Blob(chunks, { type: 'video/webm' });
      this.props.videoRecorded(blob);
    };
    this.mediaRecorder.ondataavailable = (blob) => {
      chunks.push(blob.data);
    };

    // const track = stream.getVideoTracks()[0];
    // const imageCapture = new ImageCapture(track);
    // imageCapture.getPhotoCapabilities().then(() => {
    //   this.currentVideoTrack = track;
    //   this.isFlashlightEnabled = false;
    //   this.setState({ hasFlashlight: true });
    // });

  };

  toggleFlashlightMode = () => {
    if (this.currentVideoTrack && this.state.hasFlashlight) {
      this.isFlashlightEnabled = !this.isFlashlightEnabled;
      // todo how to off?, its doesn't work
      const advanced = [{ torch: this.isFlashlightEnabled ? 'on' : 'off' }];
      try {
        this.currentVideoTrack.applyConstraints({ advanced });
      } catch (e) {
        console.log(e);
      }
    }
  };


  onMediaError = (e) => {
    this.props.fallbackMediaStreamRecord();
  };

  onBackPressed = () => {
    this.props.history.push(`/stickers/${this.props.stickerId}`);
  };

  onTryAgainPressed = (event) => {
    this.props.resetState();
    this.requestUserMedia({ needRender: true });
  };

  onDonePressed = () => {
    this.props.videoDone(this.videoRef);
  };

  onToggleLabelBar = () => {
    this.setState({ isCanvasBarShown: !this.state.isCanvasBarShown })
  };

  onCanvasSelect = (canvas) => {
    this.props.showAppModal();
  };

  onVideoContainerRef = (ref) => {
    this.videoContainerRef = ref;
  };

  // onVideoBgClicked = (event) => {
  //   event.preventDefault();
  //   this.videoRef && this.videoRef.play();
  // };

  startRecording = () => {
    this.mediaRecorder.start(1000);
    this.setState({ isRecording: true });
  };

  stopRecording = () => {
    this.mediaRecorder.stop();
    stopMediaStream(this.stream);
    this.videoEl.pause();
    this.videoEl.srcObject = null;
    this.videoContainerRef.innerHTML = '';
    this.setState({ isRecording: false });
  };

  onVideoRef = (videoRef) => {
    videoRef && videoRef.play();
    this.videoRef = videoRef;
  };

  onRecordingToggle = () => {
    if (this.state.isRecording) {
      this.stopRecording();
    } else {
      this.startRecording();
    }
  };

  _renderRecordButton = () => {
    return (
      <StickersComponentsRecordVideoBtn
        maxDuration={MAX_DURATION_SEC}
        isRecording={this.state.isRecording}
        onPress={this.onRecordingToggle}/>
    )
  };

  _renderControls = () => {
    if (this.props.mediaState.originVideoPath != null) {
      return (
        <div className={styles.doneControls}>
          <StickersComponentsTryAgainBtn
            withoutFileSelect={true}
            onPress={this.onTryAgainPressed}/>
          <UQButton label={this.props.t('doneBtn')}
                    containerClass={styles.doneBtn}
                    containerStyle={{ minWidth: 140 }}
                    theme={'whiteBrand'}
                    onPress={this.onDonePressed}/>
        </div>
      );
    }
    return (
      <div className={styles.doneControls}>
        {supportsFacingMode && (
          <button type="button"
                  className={styles.toggleCameraBtn}
                  onClick={this.toggleFacingMode}>
            <img src={cameraToggleImage} srcSet={cameraToggleImage2x} style={{ width: 41, height: 38 }}/>
          </button>
        )}
        {this._renderRecordButton()}
        {this.state.hasFlashlight && (
          <button type="button"
                  className={styles.flashBtn}
                  onClick={() => this.toggleFlashlightMode()}>
            <img src={flashImage} srcSet={flashImage2x} style={{ width: 26, height: 'auto' }}/>
          </button>
        )}
      </div>
    );
  };

  _renderVideoBg() {
    const isVideoRecorded = this.props.mediaState.originVideoPath != null;
    return (
      <Fragment>
        {isVideoRecorded && (
          <div onClick={this.onVideoBgClicked}>
            <Player
              ref={this.onVideoRef}
              preload={'metadata'}
              autoPlay={true}
              loop={true}
              playsInline
              fluid={true}
              src={this.props.mediaState.originVideoPath}>
              <ControlBar disableCompletely={true}/>
              <BigPlayButton className={styles.BigPlayButton}/>
            </Player>
          </div>
        )}
        <div className={isVideoRecorded ? styles.hidden : ''} ref={this.onVideoContainerRef}/>
      </Fragment>
    );
  }

  render() {
    return (
      <Div100vh className={styles.container}>
        <button type="button"
                onClick={this.onBackPressed}
                className={styles.headerBackBtn}>
          <UiIcon name="close" size={28} color="#FFFFFF"/>
        </button>
        <CanvasComponentsBarToggler
          onPress={this.onToggleLabelBar}
          isActive={this.state.isCanvasBarShown}
          containerClass={styles.labelsToggleTop}/>
        <CanvasComponentsControlsBottom
          isCanvasBarShown={this.state.isCanvasBarShown}
          onCanvasSelect={this.onCanvasSelect}>
          {this._renderControls()}
        </CanvasComponentsControlsBottom>
        {this._renderVideoBg()}
      </Div100vh>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    videoDone: (playerRef) => dispatch(videoDone(playerRef)),
    resetState: () => dispatch(resetState()),
    // onVideoSelected: (file) => dispatch(onVideoSelected(file)),
    showAppModal: () => dispatch(setGoAppModalVisibility(true)),
    checkStepValidation: (stepEnum) => dispatch(checkStepValidation(stepEnum)),
    fallbackMediaStreamRecord: () => dispatch(fallbackMediaStreamRecord()),
    videoRecorded: (blob) => dispatch(onVideoSelected(blob))
  }
};

const mapStateToProps = (state) => {
  return {
    stickerId: createLlamaIdSelector(state),
    mediaState: mediaVideoStateSelector(state)
  }
};

export default compose(
  withTranslation('scr-new-sticker-video'),
  connect(mapStateToProps, mapDispatchToProps)
)(StickersScreensNewVideoRecord);
